@if (variant() === 'exhaustioncard') {
<div class="p-2">
    @if (exhaustionCardState() === 'depleted') {
    <div class="flex items-center gap-4 p-4 bg-rose-50 border border-rose-200 rounded-2xl">
        <div class="w-10 h-10 rounded-full bg-rose-100 flex items-center justify-center flex-shrink-0">
            <app-icon [type]="CREDITS_SVG.AGENT_MODE" source="svg" size="default" class="text-emerald-600" />
        </div>
        <div class="flex-1 min-w-0">
            <p class="text-md font-bold text-rose-900 leading-snug">You've run out of credits</p>
            <p class="text-sm text-rose-700 leading-snug mt-0.5">
                Analysis is paused until your credits are renewed.
                <app-button label="Get Credits" class="text-red-700" variant="link" severity="contrast" size="sm"
                    icon="arrow-right" iconPosition="right" iconSource="lucide" (clicked)="openRequestDialog()" />
            </p>
        </div>
    </div>
    } @else if (exhaustionCardState() === 'ready') {
    <div class="flex items-center gap-4 p-4 bg-emerald-50 border border-emerald-200 rounded-2xl">
        <div class="w-10 h-10 rounded-full bg-emerald-100 flex items-center justify-center flex-shrink-0">
            <app-icon [type]="CREDITS_SVG.AGENT_MODE" source="svg" size="default" class="text-emerald-600" />
        </div>
        <div class="flex-1 min-w-0">
            <p class="text-md font-bold text-emerald-900 leading-snug">Your credits are topped up</p>
            <p class="text-sm text-emerald-700 leading-snug mt-0.5">
                Ready to pick up where you left off.
                <app-button label="Resume" class="text-emerald-700" variant="link" severity="contrast" size="sm"
                    icon="arrow-right" iconPosition="right" iconSource="lucide" [disabled]="isResuming()"
                    (clicked)="onResumeClick()" />
            </p>
        </div>
    </div>

    }
</div>
} @else if (variant() === 'exhaustionlayout') {
@if (exhaustionCardState() === 'depleted') {
<div class="flex flex-col h-full w-full overflow-hidden">
    <div class="flex-1 flex flex-col items-center justify-center gap-6 p-6">
        <div class="flex flex-col items-center gap-1 text-center">
            <p class="font-bold text-xl md:text-2xl font-bricolage">You've run out of credits</p>
            <p class="text-base text-gray-400 font-bricolage">Analysis is paused until your credits are renewed.</p>
        </div>
        <app-button label="Get credits" variant="filled" severity="primary" icon="sparkles" iconSource="lucide" (clicked)="openRequestDialog()" />
    </div>
    @if (bottomImageSvg()) {
    <div class="flex items-end justify-center overflow-hidden">
        <i [innerHTML]="bottomImageSvg() | sanitizeHtml" class="[&>svg]:w-[300px] [&>svg]:h-[250px]"></i>
    </div>
    }
</div>
} @else if (exhaustionCardState() === 'ready') {
<div class="flex flex-col h-full w-full overflow-hidden">
    <div class="flex-1 flex flex-col items-center justify-center gap-6 p-6">
        <div class="flex flex-col items-center gap-1 text-center">
            <p class="font-bold text-xl md:text-2xl font-bricolage">Your credits are topped up</p>
            <p class="text-base text-gray-400 font-bricolage">Ready to pick up where you left off.</p>
        </div>
        <app-button label="Resume" variant="filled" severity="primary" icon="pi pi-play-circle"
            [disabled]="isResuming()" (clicked)="onResumeClick()" />
    </div>
    @if (bottomImageSvg()) {
    <div class="flex items-end justify-center overflow-hidden">
        <i [innerHTML]="bottomImageSvg() | sanitizeHtml" class="[&>svg]:w-[300px] [&>svg]:h-[250px]"></i>
    </div>
    }
</div>
}
} @else if (variant() === 'chip') {
<div class="flex gap-2 justify-between items-center">
    <div class="flex items-center gap-2.5 px-3 h-9 bg-white/80 border rounded-xl select-none flex-shrink-0 cursor-pointer"
        [ngClass]="bothExhausted() ? 'border-red-500' : 'border-gray-200'" [pTooltip]="chipTooltip()"
        tooltipPosition="bottom" (click)="creditsPopover.toggle($event)">
        <div class="flex items-center gap-1">
            <app-icon [type]="'zap'" [source]="'lucide'" [size]="'sm'" [ngClass]="askExhausted() ? 'text-red-500' : ''" />
            <span class="text-sm font-semibold" [ngClass]="askExhausted() ? 'text-red-500' : 'text-surface-900'">{{
                askRemaining() | number:'1.0-2' }}</span>
        </div>
        <div class="w-px h-3.5" [ngClass]="bothExhausted() ? 'bg-red-500' : 'bg-gray-300'"></div>
        <div class="flex items-center gap-1">
            <app-icon [type]="CREDITS_SVG.AGENT_MODE" [source]="'svg'" [size]="'sm'" [ngClass]="agentExhausted() ? 'text-red-500 icon-force-color' : 'text-violet-500'" />
            <span class="text-sm font-semibold" [ngClass]="agentExhausted() ? 'text-red-500' : 'text-surface-900'">{{
                agentRemaining() | number:'1.0-2' }}</span>
        </div>
    </div>
    @if (showGetCreditsInChip() && isTrial()) {
    <span [pTooltip]="!canRequestCredits() ? 'Enable at least one of agent or ask mode to add credits' : undefined"
        tooltipPosition="top" class="inline-flex">
        <app-button label="Get Credits" variant="filled" severity="primary" [size]="'sm'"
            [disabled]="!canRequestCredits()" (clicked)="openRequestDialog()" />
    </span>
    }
</div>
<p-popover #creditsPopover appendTo="body" [style]="{ padding: '0' }"
    styleClass="!p-0 !rounded-2xl !overflow-hidden !shadow-xl !border !border-gray-200">
    <div>
        <ng-container *ngTemplateOutlet="mainContent" />
    </div>
</p-popover>
} @else {
<ng-container *ngTemplateOutlet="mainContent" />
}

<ng-template #mainContent>
    <!-- Width is fixed only in popover (layout/chip); cards variant fills its container -->
    <div class="bg-white overflow-hidden flex flex-col"
        [ngClass]="variant() !== 'cards' ? 'rounded-2xl sm:w-[40rem] w-full' : 'w-full'">

        @if (needHeader()) {
        <div class="flex items-center border-b px-2 pb-2 border-gray-100 flex-shrink-0">
            <h3 class="text-md font-bold text-gray-900">Credits remaining</h3>
        </div>
        }

        <!-- Cards variant: no height constraint, no dividers, gap between cards -->
        <!-- Layout variant: fixed 12rem height, divide-x between columns -->
        <div
            [ngClass]="variant() === 'cards'
            ? 'grid grid-cols-1 xl:grid-cols-2 gap-4'
            : ['flex-shrink-0 grid grid-cols-1 sm:grid-cols-2 sm:h-[14rem] divide-y sm:divide-y-0 sm:divide-x', bothExhausted() ? 'divide-red-300' : 'divide-gray-100']">

            @for (mode of modes(); track mode.title) {
            <div class="flex flex-col"
                [ngClass]="variant() === 'cards' ? ['gap-3 p-5 shadow-sm border rounded-xl', mode.exhausted ? 'border-red-300' : 'border-gray-100'] : 'gap-2 px-5 py-4'">

                <!-- Title row: icon + name/subtitle + badge -->
                <div class="flex items-start justify-between gap-2">
                    <div class="flex items-center gap-2.5">
                        <div class="w-9 h-9 rounded-xl flex items-center justify-center flex-shrink-0"
                            [ngClass]="mode.iconBg">
                            <app-icon [type]="mode.iconType" [source]="mode.iconSource" [size]="'default'"
                                [ngClass]="mode.iconColor" />
                        </div>
                        <div>
                            <p class="text-sm font-bold text-gray-900 leading-tight">{{ mode.title }}</p>
                            <p class="text-xs text-gray-400 leading-tight mt-0.5">{{ mode.subtitle }}</p>
                        </div>
                    </div>
                    @if (mode.severity.label !== 'N/A') {
                    <span class="text-xs font-medium px-2 py-0.5 rounded-full flex-shrink-0 mt-0.5"
                        [ngClass]="mode.severity.classes">
                        {{ mode.severity.label }}
                    </span>
                    }
                </div>

                @if (variant() === 'cards') {
                <!-- Cards (page) variant: [number + meta] left | [bricks + legend] right -->
                <div class="flex items-start justify-between gap-4">
                    <!-- Left: number + meta -->
                    <div class="flex flex-col flex-shrink-0">
                        <div class="flex items-baseline gap-1.5">
                            <span class="text-3xl font-bold" [ngClass]="mode.textColor">{{ mode.consumed | number
                                }}</span>
                            <span class="text-base text-gray-400">/{{ mode.allocated | number }}</span>
                        </div>
                        <p class="text-xs text-gray-400">credits consumed
                            @if (mode.resets !== null) {
                            <span class="text-gray-300">•</span>
                            <span> Resets on {{ mode.expires }}</span>
                            }
                        </p>
                        <p class="text-xs flex items-center gap-1 flex-wrap mt-3">
                            <span [ngClass]="mode.exhausted ? 'text-red-500 font-semibold' : 'text-gray-400'">{{
                                mode.remaining | number }} credits remaining</span>
                        </p>
                    </div>
                    <!-- Right: bricks + legend aligned beneath -->
                    <div class="flex flex-col gap-4">
                        <ng-container *ngTemplateOutlet="brickViz; context: {
                            rows: mode.brickRows,
                            consumedCredits: mode.consumed,
                            consumed: mode.blockConsumed,
                            remaining: mode.blockRemaining,
                            size: 'md'
                        }" />
                        <div class="flex items-center justify-between gap-4">
                            <div class="flex items-center gap-3">
                                <div class="flex items-center gap-1.5">
                                    <div class="w-2.5 h-2.5 rounded-sm" [ngClass]="mode.blockRemaining"></div>
                                    <span class="text-xs text-gray-400">Remaining</span>
                                </div>
                                <div class="flex items-center gap-1.5">
                                    <div class="w-2.5 h-2.5 rounded-sm" [ngClass]="mode.blockConsumed"></div>
                                    <span class="text-xs text-gray-400">Consumed</span>
                                </div>
                            </div>
                            <span class="text-xs font-semibold" [ngClass]="mode.textColor">{{ mode.consumedPct }}%
                                used</span>
                        </div>
                    </div>
                </div>
                } @else {
                <!-- Layout/chip (popover) variant: stacked -->
                <div class="mt-2">
                    <div class="flex items-baseline gap-1.5">
                        <span class="text-2xl font-bold leading-none" [ngClass]="mode.textColor">
                            {{ mode.consumed | number }}
                        </span>
                        <span class="text-sm text-gray-400">/{{ mode.allocated | number }}</span>
                    </div>
                    <p class="text-xs text-gray-400 mt-0.5">credits consumed
                        <span class="text-gray-300">•</span>
                        <span [ngClass]="mode.exhausted ? 'text-red-500 font-semibold' : ''"> {{ mode.remaining | number
                            }} credits remaining</span>
                    </p>
                    <!-- Meta line -->
                    <p class="text-xs text-gray-400 flex items-center gap-1 flex-wrap mt-2">
                        @if (mode.resets !== null) {
                        <span>Resets in {{ mode.resets }} day{{ mode.resets === 1 ? '' : 's' }}</span>
                        <span class="text-gray-300">•</span>
                        <span>{{ mode.expires }}</span>
                        }
                    </p>
                </div>
                <ng-container *ngTemplateOutlet="brickViz; context: {
                    rows: mode.brickRows,
                    consumedCredits: mode.consumed,
                    consumed: mode.blockConsumed,
                    remaining: mode.blockRemaining,
                    size: 'sm'
                }" />

                <!-- Legend + % used -->
                <div class="flex items-center justify-between mt-auto">
                    <div class="flex items-center gap-3">
                        <div class="flex items-center gap-1.5">
                            <div class="w-2.5 h-2.5 rounded-sm" [ngClass]="mode.blockRemaining"></div>
                            <span class="text-xs text-gray-400">Remaining</span>
                        </div>
                        <div class="flex items-center gap-1.5">
                            <div class="w-2.5 h-2.5 rounded-sm" [ngClass]="mode.blockConsumed"></div>
                            <span class="text-xs text-gray-400">Consumed</span>
                        </div>
                    </div>
                    <span class="text-xs font-semibold" [ngClass]="mode.textColor">{{ mode.consumedPct }}% used</span>
                </div>
                }

            </div>
            }

        </div>

        <ng-template #brickViz let-rows="rows" let-consumed="consumed" let-remaining="remaining"
            let-consumedCredits="consumedCredits" let-size="size">
            <div class="flex flex-col gap-[6px]" [pTooltip]="consumedCredits + ' consumed credits'"
                tooltipPosition="top">
                @for (row of rows; track $index) {
                <div class="flex" [ngClass]="[
                        size === 'lg' ? 'gap-[4px]' : 'gap-1.5',
                        $index % 2 !== 0 ? (size === 'lg' ? 'ml-[15px]' : 'ml-3') : ''
                    ]">
                    @for (fillRatio of row; track $index) {
                    <div class="rounded-sm overflow-hidden flex-shrink-0"
                        [ngClass]="[size === 'lg' ? 'w-6 h-2.5' : 'w-5 h-2', remaining]">
                        @if (fillRatio > 0) {
                        <div class="h-full transition-all" [ngClass]="consumed" [style.width.%]="fillRatio * 100">
                        </div>
                        }
                    </div>
                    }
                </div>
                }
            </div>
        </ng-template>

        @if (needActionButtons()) {
        <div class="flex items-center justify-end pr-2 pt-3 gap-2 border-t border-gray-100 flex-shrink-0">
            @if (showViewUsage()) {
            <app-button label="View usage" variant="outlined" severity="contrast" [size]="'sm'"
                (clicked)="navigateToUsage()" />
            }
            @if (showGetCredits() && isTrial()) {
            <span
                [pTooltip]="!canRequestCredits() ? 'Enable at least one of agent or ask mode to add credits' : undefined"
                tooltipPosition="top" class="inline-flex">
                <app-button label="Get credits" variant="filled" severity="primary" [size]="'sm'"
                    [disabled]="!canRequestCredits()" (clicked)="openRequestDialog()" />
            </span>
            }
        </div>
        }

    </div>
</ng-template>

<app-dialog [visible]="requestDialogVisible()" (visibleChange)="requestDialogVisible.set($event)"
    title="Request Credits" description="Specify how many credits you need for each mode." class="max-w-sm">
    <ng-template #bodyTemplate>
        <div class="flex flex-col gap-5 px-1 py-2">
            @if (isAskModeEnabled()) {
            <div class="flex flex-col gap-1.5">
                <label class="text-sm font-medium text-gray-700 flex items-center gap-1.5">
                    <app-icon type="zap" source="lucide" size="sm" />
                    Ask Credits
                </label>
                <app-input type="number" placeholder="Enter amount" [min]="0" [ngModel]="askRequest()?.toString() ?? ''"
                    (valueChange)="askRequest.set(+$event || null)" />
            </div>
            }
            @if (isAgentModeEnabled()) {
            <div class="flex flex-col gap-1.5">
                <label class="text-sm font-medium text-gray-700 flex items-center gap-1.5">
                    <app-icon [type]="CREDITS_SVG.AGENT_MODE" source="svg" size="sm" class="theme-text" />
                    Agent Credits
                </label>
                <app-input type="number" placeholder="Enter amount" [min]="0"
                    [ngModel]="agentRequest()?.toString() ?? ''" (valueChange)="agentRequest.set(+$event || null)" />
            </div>
            }
        </div>
    </ng-template>
    <ng-template #footerTemplate>
        <div class="flex justify-end gap-2 w-full">
            <app-button label="Cancel" variant="outlined" severity="contrast" [size]="'sm'"
                (clicked)="requestDialogVisible.set(false)" />
            <app-button label="Request Credits" variant="filled" severity="primary" [size]="'sm'"
                [enableThrottle]="true" [disabled]="(!askRequest() && !agentRequest())" (clicked)="submitRequest()" />
        </div>
    </ng-template>
</app-dialog>